import styled from 'styled-components'
import { theme } from './../../common'

export const ImageWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: white;
    -webkit-text-stroke: 1px ${theme.primary};
    text-stroke: 1px ${theme.primary};
    img {
        width: 100%;
        height: auto;
        max-width: 810px;
    }
`

export const TextOverLay = styled.h2`
    font-size: 3em;
    font-weight: bold;
    color: transparent;
    position: absolute;
    bottom: -.75em;
    left: -.25em;
    z-index: 10;
    text-transform: uppercase;
    --webkit-text-stroke: 1px ${theme.primary};

    @media screen and (max-width: 992px) {
        font-size: 2.5em;
    }
`

export const Title = styled.h1`
    font-size: 2em;
    text-transform: uppercase;
    font-weight: bold;
    
    @media screen and (max-width: 992px) {
        font-size: 1.8em;
        margin-top: 2%;
    }
`

export const Content = styled.div`
    margin: 0px;
    font-size: 1em;

    ul{
        list-style-type: none;
        padding: 0px;
        li{
            display: flex;
            flex-direction: row;
            &:before {
                content: '\\e906';
                font-family: 'icomoon' !important;
                color: ${theme.primary};
                font-size: 1em;
                margin-right: .5em;
            }
        }
    }

    @media screen and (max-width: 992px) {
    }
`
